import {useCallback, useRef} from 'react';
import {getAppOrigin} from 'coreUtils/url';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import {DATALAYER_CONFIGS} from 'brandConstants';
import {EEventType} from 'coreClasses/events/IEvents';

export const useTrackPromotionEvent = () => {
	const {managerRepository} = useGeneralProvider();
	const {trackedQueryParameters} = DATALAYER_CONFIGS?.promotionEvent || {};
	const currentEventReference = useRef(null);

	const trackPromotionEvent = useCallback(
		(url: string, eventType: EEventType) => {
			if (!url || !eventType) {
				return null;
			}

			const [pathname, queryParams] = url.split('?');
			const urlSearchParams = new URLSearchParams(queryParams);
			const matchingParams = trackedQueryParameters.filter((param) => urlSearchParams.has(param));

			if (matchingParams.length === 0) {
				return null;
			}

			if (currentEventReference?.current === null || currentEventReference?.current !== pathname) {
				currentEventReference.current = pathname;
				matchingParams.forEach((trackedQueryParam) => {
					const trackedQueryParamValue = urlSearchParams.get(trackedQueryParam);
					const promoArray = trackedQueryParamValue.split('_');

					managerRepository.getEventsMgr().emit(eventType, {
						id: `${promoArray[0]}_${promoArray[1]}`,
						name: promoArray[0],
						creative: `${getAppOrigin()}${url.split('?')[0]}`,
						position: `${promoArray[2]}_${promoArray[3]}_${promoArray[4]}`,
					});
				});
			}
		},
		[trackedQueryParameters, managerRepository],
	);

	return {trackPromotionEvent};
};
